export default __webpack_public_path__ + "assets/bobw-tallinn-kesklinn.d16ac9d8387f13a0495587df51754b83.webp";